import { MEMBER_STATUS } from './copy.js';
import { PERMISSIONS } from './permissions.js';

/** Per-row actions of the Members list kebab menu. */
export const MEMBER_ACTION = Object.freeze({
  RESET_PASSWORD: 'resetPassword',
  SUSPEND: 'suspend',
  REACTIVATE: 'reactivate',
  SEND_INVITATION: 'sendInvitation',
  RESEND_INVITATION: 'resendInvitation',
  EDIT_EMAIL: 'editEmail',
  REVOKE_INVITATION: 'revokeInvitation',
});

/** Actions of the bulk bar over the selected rows. */
export const MEMBER_BULK_ACTION = Object.freeze({
  SEND_INVITATIONS: 'sendInvitations',
  SUSPEND: 'suspend',
  REMOVE: 'remove',
});

/** What a lifecycle action asks the service to do (`setMemberStatus(id, request)`). */
export const MEMBER_STATUS_REQUEST = Object.freeze({
  SUSPEND: 'suspend',
  REACTIVATE: 'reactivate',
  REMOVE: 'remove',
  REVOKE: 'revoke',
});

/** Row actions per member status, in menu order (prototype screen 02). */
export const MEMBER_ACTIONS_BY_STATUS = Object.freeze({
  [MEMBER_STATUS.ACTIVE]: [MEMBER_ACTION.RESET_PASSWORD, MEMBER_ACTION.SUSPEND],
  [MEMBER_STATUS.NOT_INVITED]: [MEMBER_ACTION.SEND_INVITATION, MEMBER_ACTION.EDIT_EMAIL],
  [MEMBER_STATUS.INVITED]: [
    MEMBER_ACTION.RESEND_INVITATION,
    MEMBER_ACTION.EDIT_EMAIL,
    MEMBER_ACTION.REVOKE_INVITATION,
  ],
  [MEMBER_STATUS.EXPIRED]: [
    MEMBER_ACTION.RESEND_INVITATION,
    MEMBER_ACTION.EDIT_EMAIL,
    MEMBER_ACTION.REVOKE_INVITATION,
  ],
  [MEMBER_STATUS.SUSPENDED]: [MEMBER_ACTION.RESET_PASSWORD, MEMBER_ACTION.REACTIVATE],
  [MEMBER_STATUS.REMOVED]: [],
});

/**
 * Permission each action needs. Placeholder mapping (contract TBD with ARP/backend, CT-5569):
 * invitation work needs `MEMBERS_INVITE`, everything that changes someone's access needs
 * `MEMBERS_REMOVE`.
 */
export const MEMBER_ACTION_PERMISSION = Object.freeze({
  [MEMBER_ACTION.RESET_PASSWORD]: PERMISSIONS.MEMBERS_REMOVE,
  [MEMBER_ACTION.SUSPEND]: PERMISSIONS.MEMBERS_REMOVE,
  [MEMBER_ACTION.REACTIVATE]: PERMISSIONS.MEMBERS_REMOVE,
  [MEMBER_ACTION.SEND_INVITATION]: PERMISSIONS.MEMBERS_INVITE,
  [MEMBER_ACTION.RESEND_INVITATION]: PERMISSIONS.MEMBERS_INVITE,
  [MEMBER_ACTION.EDIT_EMAIL]: PERMISSIONS.MEMBERS_INVITE,
  [MEMBER_ACTION.REVOKE_INVITATION]: PERMISSIONS.MEMBERS_INVITE,
});

export const MEMBER_BULK_ACTION_PERMISSION = Object.freeze({
  [MEMBER_BULK_ACTION.SEND_INVITATIONS]: PERMISSIONS.MEMBERS_INVITE,
  [MEMBER_BULK_ACTION.SUSPEND]: PERMISSIONS.MEMBERS_REMOVE,
  [MEMBER_BULK_ACTION.REMOVE]: PERMISSIONS.MEMBERS_REMOVE,
});
